var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClaims(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6183 13.9885C11.5631 13.9465 11.506 13.9031 11.4526 13.8602C11.1691 13.633 10.8675 13.4235 10.5758 13.221C10.5153 13.179 10.4548 13.137 10.3945 13.0948C10.0208 12.8334 9.68493 12.7064 9.36758 12.7064C8.94015 12.7064 8.56748 12.9416 8.25989 13.4055C8.15311 13.5666 7.64404 13.3802 7.47472 13.3037C6.26874 12.759 5.40759 11.9239 4.91514 10.8216C4.67709 10.2888 4.62727 10.2461 5.04622 9.96269C5.28413 9.80187 5.72695 9.50248 5.69558 8.92916C5.66006 8.27811 4.21773 6.31917 3.61002 6.09668C3.35272 6.00244 3.08238 6.00156 2.80507 6.09448C2.10645 6.32839 1.60511 6.73917 1.35512 7.28234C1.11355 7.80719 1.12446 8.42345 1.38668 9.06452C2.14472 10.918 3.2105 12.534 4.55451 13.8675C5.87005 15.1729 7.48697 16.2422 9.36031 17.0456C9.52916 17.118 9.70627 17.1574 9.8356 17.1862C9.87968 17.1961 9.91773 17.2045 9.94546 17.2121C9.96071 17.2162 9.97643 17.2184 9.99219 17.2187H10.007C10.8881 17.2187 11.9461 16.4168 12.271 15.5026C12.5557 14.7021 12.036 14.3064 11.6183 13.9885Z",
    stroke: "#714FFF",
    strokeWidth: 1.25
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1674 1.35059H9.05442C8.33362 1.35059 7.7002 1.78567 7.7002 2.50356V8.44243C7.71094 9.19013 8.3044 9.80026 9.05442 9.83469H12.4666C12.5791 9.82807 12.6895 9.86734 12.7724 9.94345L15.1571 12.4997C15.2391 12.5876 15.3861 12.5482 15.413 12.431L15.9395 10.1392C15.9824 9.94895 16.1593 9.81912 16.3545 9.83469H18.1674C18.8882 9.83469 19.3687 9.16032 19.3687 8.44243V2.50356C19.3687 1.78567 18.8882 1.35059 18.1674 1.35059Z",
    stroke: "#714FFF",
    strokeWidth: 1.25
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6556 4.31836L16.4121 4.31836",
    stroke: "#714FFF",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6555 6.83936L13.5254 6.83936",
    stroke: "#714FFF",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClaims);
export default __webpack_public_path__ + "static/media/Claims.5fa95e861cfaa5b674625dc397908ec5.svg";
export { ForwardRef as ReactComponent };